
import Accordion from './Accordion';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';



function Forcedwarmermumbai() {



  const cardData =
  {
    keyword: 'Patient Forced Air Warmer in Mumbai',
    heading: 'Pharmacle Health Care Private Limited: Patient Forced Air Warmer in Mumbai',
    headingDescription: 'Pharmacle Health Care Private Limited offers the Patient Forced Air Warmer in Mumbai, providing advanced temperature management solutions for hospitals and healthcare facilities. Our Wallabies Warm Care systems ensure uniform and efficient warming, reducing the risk of hypothermia during surgeries and critical care. Designed with cutting-edge technology, our forced air warmers deliver reliability, safety, and patient comfort. Trusted by medical professionals, we guarantee high-quality performance for better patient outcomes. Choose Pharmacle Health Care for the best forced air warmer in Mumbai.',

    top: 'Pharmacle Health Care Private Limited – Leading Provider of Forced Air-Warming Systems & Blankets',

    "topPlaces": [
  {
    "title": "Patient Forced Air Warmer in Mumbai",
    "description": "Pharmacle Health Care Private Limited offers state-of-the-art patient forced air warmers in Mumbai, engineered to provide controlled and consistent warming during medical procedures. These systems ensure effective thermal regulation and reduce the risk of perioperative hypothermia."
  },
  {
    "title": "Surgical Patient Warming System in Mumbai",
    "description": "Our surgical patient warming systems are designed for operating theaters in Mumbai hospitals, ensuring precise temperature management throughout procedures. They help maintain normothermia and support improved recovery rates."
  },
  {
    "title": "Portable Patient Air Warmer in Mumbai",
    "description": "Pharmacle Health Care Private Limited provides portable patient air warmers in Mumbai, offering lightweight and easy-to-use solutions for hospitals, clinics, and ambulances. They deliver rapid warming for emergencies and post-surgical care."
  },
  {
    "title": "Pediatric Forced Air Warmer in Mumbai",
    "description": "Our pediatric forced air warmers in Mumbai deliver gentle, controlled warming for newborns and children. Pharmacle Health Care Private Limited ensures safety and comfort in neonatal and pediatric care units."
  },
  {
    "title": "ICU Patient Forced Air Warmer in Mumbai",
    "description": "Pharmacle Health Care Private Limited supplies ICU-ready forced air warmers in Mumbai, providing advanced thermal support for critical care patients. These systems maintain stable body temperature and minimize risks in intensive care."
  },
  {
    "title": "Emergency Air Warming System in Mumbai",
    "description": "Ideal for ambulances and emergency rooms in Mumbai, our emergency air warming systems rapidly stabilize patient temperature during trauma or shock. Pharmacle Health Care Private Limited supports critical care with reliable technology."
  },
  {
    "title": "Disposable Air Warmer Blankets in Mumbai",
    "description": "Pair Pharmacle Health Care Private Limited’s forced air warmers with disposable air warmer blankets in Mumbai for safe, hygienic, and efficient warming solutions. These single-use blankets minimize infection risks and maintain optimal patient safety."
  },
  {
    "title": "Veterinary Patient Air Warmer in Mumbai",
    "description": "Supporting animal care in Mumbai, Pharmacle Health Care Private Limited provides veterinary patient air warmers designed for pets and livestock. These systems ensure precise temperature control during veterinary surgeries and treatments."
  },
  {
    "title": "Advanced Temperature-Controlled Air Warmer in Mumbai",
    "description": "Our advanced temperature-controlled air warmers in Mumbai allow precise heat adjustment for various medical applications. Pharmacle Health Care Private Limited’s systems ensure consistent warming, improving surgical outcomes and patient safety."
  },
  {
    "title": "Preoperative Patient Air Warmer in Mumbai",
    "description": "Pharmacle Health Care Private Limited supplies preoperative patient air warmers in Mumbai, designed to maintain normothermia before surgery. These systems help reduce postoperative complications and enhance overall patient care."
  }
],


"services": [
    {
        "name": "Patient Forced Air Warmer Mumbai",
        "description": "Pharmacle Health Care Private Limited offers high-quality patient forced air warmers in Mumbai. These devices are designed to provide consistent and effective temperature control, ensuring patient safety and comfort during medical procedures and post-operative recovery."
    },
    {
        "name": "Mumbai Forced Air Warming System",
        "description": "Our forced air warming systems in Mumbai are designed to provide reliable and efficient temperature regulation during surgeries and medical treatments. These systems help prevent hypothermia, ensuring optimal conditions for patient care."
    },
    {
        "name": "Mumbai Patient Warming Device",
        "description": "We provide state-of-the-art patient warming devices in Mumbai, designed to maintain a stable and comfortable body temperature for patients during surgical procedures and critical care, reducing the risk of complications."
    },
    {
        "name": "Patient Warming Solutions Mumbai",
        "description": "Pharmacle Health Care offers comprehensive patient warming solutions in Mumbai, including forced air warming systems, warming blankets, and temperature regulation devices. These solutions are designed to ensure patient safety and comfort throughout medical treatments."
    },
    {
        "name": "Forced Air Warmer Equipment Mumbai",
        "description": "Our forced air warmer equipment in Mumbai is designed for effective temperature management in medical environments. These devices provide controlled warmth to patients, preventing hypothermia and improving recovery during surgeries and medical procedures."
    },
    {
        "name": "Patient Warming Devices Mumbai",
        "description": "Pharmacle Health Care provides advanced patient warming devices in Mumbai that ensure precise temperature regulation. These devices are essential for patient safety in surgical and critical care environments, helping to reduce risks and improve comfort."
    },
    {
        "name": "Mumbai Thermoregulation System",
        "description": "We offer thermoregulation systems in Mumbai that are designed to maintain optimal body temperature for patients during surgeries, emergency care, and post-operative recovery. Our systems prevent hypothermia and enhance patient safety."
    },
    {
        "name": "Mumbai Temperature Control Warming Devices",
        "description": "Our temperature control warming devices in Mumbai are engineered to provide safe and reliable temperature regulation for patients. These devices are crucial in maintaining patient comfort and preventing temperature-related complications during medical treatments."
    },
    {
        "name": "Mumbai Hospital Warming Equipment",
        "description": "Pharmacle Health Care supplies hospital warming equipment in Mumbai, designed for use in operating rooms, emergency care, and post-operative recovery. Our equipment ensures safe, effective temperature management for patients, improving recovery outcomes."
    }
],
"tableData": [
    ["- Patient Forced Air Warmer Mumbai", "- Mumbai Forced Air Warming System"],
    ["- Mumbai Patient Warming Device", "- Patient Warming Solutions Mumbai"],
    ["- Forced Air Warmer Equipment Mumbai", "- Patient Warming Devices Mumbai"],
    ["- Mumbai Thermoregulation System", "- Mumbai Temperature Control Warming Devices"],
    ["- Mumbai Hospital Warming Equipment"]
],

"whychoose": [
    {
        "WhyChooseheading": "Advanced and Reliable Warming Technology",
        "WhyChoosedescription": "Pharmacle Health Care Private Limited offers cutting-edge forced air warming systems in Mumbai, providing precise temperature control during medical treatments. Our technology ensures reliable performance to prevent hypothermia, enhancing patient safety in hospitals and clinics throughout Mumbai."
    },
    {
        "WhyChooseheading": "Comprehensive Patient Warming Solutions",
        "WhyChoosedescription": "We offer a comprehensive range of patient warming solutions, including forced air warming devices and blankets in Mumbai. Our products are designed for both surgical procedures and critical care, ensuring patient comfort and safety throughout medical treatments."
    },
    {
        "WhyChooseheading": "High-Quality, Durable Equipment",
        "WhyChoosedescription": "Our patient warming equipment is manufactured to the highest standards, ensuring durability and reliable long-term performance. Regularly serviced and rigorously tested, our equipment provides optimal reliability for continuous use in Mumbai’s medical environments."
    },
    {
        "WhyChooseheading": "Safe and Comfortable for Patients",
        "WhyChoosedescription": "Patient comfort and safety are at the forefront of our priorities. Our forced air warming blankets and devices provide controlled, gentle warmth, preventing temperature-related complications during surgeries and procedures, ensuring patients in Mumbai are in the safest hands."
    },
    {
        "WhyChooseheading": "Flexible Solutions for Healthcare Providers",
        "WhyChoosedescription": "Our patient warming systems are adaptable to various healthcare settings in Mumbai, including hospitals, clinics, and emergency rooms. We work closely with healthcare providers to ensure our systems meet their unique needs and requirements."
    },
    {
        "WhyChooseheading": "Easy Integration with Existing Systems",
        "WhyChoosedescription": "Pharmacle Health Care’s patient warming solutions are designed to integrate seamlessly with existing medical systems in Mumbai. Our products are easy to implement, ensuring a smooth experience for healthcare professionals without disrupting ongoing procedures."
    },
    {
        "WhyChooseheading": "Expert Consultation and Support",
        "WhyChoosedescription": "We provide expert consultation services to help healthcare facilities in Mumbai select the most suitable warming solutions. Our team also offers ongoing support and maintenance to ensure the equipment operates efficiently and effectively."
    },
    {
        "WhyChooseheading": "Commitment to Patient Safety and Comfort",
        "WhyChoosedescription": "At Pharmacle Health Care, patient safety and comfort are integral to our philosophy. Our warming systems are specifically designed to prevent temperature-related issues during critical medical procedures, ensuring that patients in Mumbai receive the highest standard of care."
    }
]





  }




  const faqData = [
    { question: "What is a Patient Forced Air Warmer?", answer: "A Patient Forced Air Warmer is a medical device designed to maintain or restore a patient's body temperature during surgeries or treatments by circulating warm air through a specialized warming blanket." },
    { question: "How does a Patient Forced Air Warmer work?", answer: "The Patient Forced Air Warmer works by blowing warm air into a blanket or clothing that is placed on the patient, maintaining a comfortable and controlled body temperature during medical procedures." },
    { question: "Is the Patient Forced Air Warmer available in Mumbai?", answer: "Yes, Pharmacle Health Care Private Limited offers the Patient Forced Air Warmer in Mumbai, ensuring healthcare facilities can access this crucial product for patient comfort and safety." },
    { question: "What are the advantages of using a Patient Forced Air Warmer?", answer: "It helps prevent hypothermia, reduces the risk of surgical site infections, promotes faster recovery, and enhances overall patient comfort during medical procedures." },
    { question: "How long does the Patient Forced Air Warmer keep the patient warm?", answer: "The Patient Forced Air Warmer provides warmth for as long as necessary during medical procedures or treatments, adjusting based on patient needs and procedure duration." },
    { question: "Is the Patient Forced Air Warmer easy to use?", answer: "Yes, the system is designed to be user-friendly with simple controls, allowing healthcare professionals to quickly and efficiently adjust the warmth for the patient's comfort." },
    { question: "Can the Patient Forced Air Warmer be used in all types of medical procedures?", answer: "Yes, the Patient Forced Air Warmer is versatile and can be used during surgeries, post-operative recovery, or any medical procedure that requires temperature regulation." },
    { question: "Are there any specific precautions when using the Patient Forced Air Warmer?", answer: "The system should be used according to the manufacturer's guidelines to ensure patient safety. It is important to monitor the patient’s body temperature to avoid overheating or skin irritation." },
    { question: "How can I purchase a Patient Forced Air Warmer in Mumbai?", answer: "You can contact Pharmacle Health Care Private Limited directly, and our team will guide you through the ordering and delivery process for Mumbai." },
    { question: "Does Pharmacle Health Care offer support for the Patient Forced Air Warmer?", answer: "Yes, we offer full support for the Patient Forced Air Warmer, including installation, training for healthcare staff, and ongoing maintenance services." }
  ];
  
  const testimonialsData = [
    {
      text: 'We have been using the Patient Forced Air Warmer in our hospital in Mumbai. It has greatly improved patient outcomes, especially in surgeries where maintaining body temperature is critical.',
      name: 'Dr. Rajesh Mehta',
    },
    {
      text: 'The Patient Forced Air Warmer from Pharmacle Health Care has been a game-changer for our clinic in Mumbai. It’s easy to use, reliable, and ensures our patients remain comfortable and safe during their treatments.',
      name: 'Dr. Priya Deshmukh',
    }
  ];
  
  
  























  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8956322311",
      "+91 8421773700",

    ],
    email: "info@wallabieswarmcares.com"
  };


const Images = [
  {
    place: "/images/keyword/1.jpg",
    text: "Patient Forced Air Warming System in Pune",
    link: "/Patient-Forced-Air-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/2.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi",
  },
  {
    place: "/images/keyword/3.jpg",
    text: "Patient Forced Air Warmer in Mumbai",
    link: "/Patient-Forced-Air-Warmer-in-Mumbai",
  },
  {
    place: "/images/keyword/5.jpg",
    text: "Patient Warming Systems in Chennai",
    link: "/Patient-Warming-Systems-in-Chennai",
  },
  {
    place: "/images/keyword/6.jpg",
    text: "Patient Warmer in Bengaluru",
    link: "/Patient-Warmer-in-Bengaluru",
  },
  {
    place: "/images/keyword/7.jpg",
    text: "Normothermia Equipment in Hyderabad",
    link: "/Normothermia-Equipment-in-Hyderabad",
  },
  {
    place: "/images/keyword/8.jpg",
    text: "Patient Thermoregulation System in Ahmedabad",
    link: "/Patient-Thermoregulation-System-in-Ahmedabad",
  },
  {
    place: "/images/keyword/9.jpg",
    text: "Patient Warming Devices in Kolkata",
    link: "/Patient-Warming-Devices-in-Kolkata",
  },
  {
    place: "/images/keyword/10.jpg",
    text: "Patient Warming Blankets in Jaipur",
    link: "/Patient-Warming-Blankets-in-Jaipur",
  },
  {
    place: "/images/keyword/12.jpg",
    text: "Patient Forced Air Warming System in Surat",
    link: "/Patient-Forced-Air-Warming-System-in-Surat",
  },
  {
    place: "/images/keyword/13.jpg",
    text: "Forced Air Warming Blankets in Coimbatore",
    link: "/Forced-Air-Warming-Blankets-in-Coimbatore",
  },
  {
    place: "/images/keyword/14.jpg",
    text: "Patient Warming Blankets in Lucknow",
    link: "/Patient-Warming-Blankets-in-Lucknow",
  },
  {
    place: "/images/keyword/15.jpg",
    text: "Patient Forced Air Warmer in Chandigarh",
    link: "/Patient-Forced-Air-Warmer-in-Chandigarh",
  },
  {
    place: "/images/keyword/17.jpg",
    text: "Thermoregulation Systems in Indore",
    link: "/Thermoregulation-Systems-in-Indore",
  },
  {
    place: "/images/keyword/18.jpg",
    text: "Patient Warming Systems in Patna",
    link: "/Patient-Warming-Systems-in-Patna",
  },
  {
    place: "/images/keyword/19.jpg",
    text: "Patient Forced Air Warming System in Hyderabad",
    link: "/Patient-Forced-Air-Warming-System-in-Hyderabad",
  },
  {
    place: "/images/keyword/20.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi NCR",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR",
  },
  {
    place: "/images/keyword/21.jpg",
    text: "Forced Air Warming System in Noida",
    link: "/Forced-Air-Warming-System-in-Noida",
  },
  {
    place: "/images/keyword/22.jpg",
    text: "Patient Warming Devices in Bhopal",
    link: "/Patient-Warming-Devices-in-Bhopal",
  },
  {
    place: "/images/keyword/23.jpg",
    text: "Patient Warming Blankets in Kochi",
    link: "/Patient-Warming-Blankets-in-Kochi",
  },
  {
    place: "/images/keyword/24.jpg",
    text: "Patient Warming System in Pune",
    link: "/Patient-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/25.jpg",
    text: "Forced Air Warming Blankets in Bengaluru",
    link: "/Forced-Air-Warming-Blankets-in-Bengaluru",
  },
  {
    place: "/images/keyword/26.jpg",
    text: "Patient Warming Devices in Chennai",
    link: "/Patient-Warming-Devices-in-Chennai",
  },
  {
    place: "/images/keyword/27.jpg",
    text: "Patient Thermoregulation System in Surat",
    link: "/Patient-Thermoregulation-System-in-Surat",
  },
];


  const images = [
    { src: "/images/keyword/1.jpg", alt: "Image 1" },
    { src: "/images/keyword/5.jpg", alt: "Image 1" },
    { src: "/images/keyword/2.jpg", alt: "Image 1" },
    { src: "/images/keyword/18.jpg", alt: "Image 1" },
    { src: "/images/keyword/4.jpg", alt: "Image 1" },
    { src: "/images/keyword/7.jpg", alt: "Image 1" },
    { src: "/images/keyword/8.jpg", alt: "Image 1" },
    { src: "/images/keyword/19.jpg", alt: "Image 1" },
    { src: "/images/keyword/6.jpg", alt: "Image 1" },

  ];


  const jsonData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Patient Forced Air Warmer in Mumbai",
    "description": "Find high-quality Patient Forced Air Warmers in Mumbai for effective temperature control and patient warming solutions during medical procedures. Ensure optimal patient comfort and safety with our advanced warming devices.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.8",
      "ratingCount": "2646"
    }
  };
  

  


  return (
    <div>
  <Helmet>
    <title>Patient Forced Air Warmer in Mumbai | Contact: +91 8956322311</title>
    <meta
      name="description"
      content="Find high-quality Patient Forced Air Warmers in Mumbai for temperature control and patient warming solutions during medical procedures. Contact us at +91 8956322311."
    />
    <meta
      name="keywords"
      content="Patient Forced Air Warmer Mumbai, Mumbai Forced Air Warming System, Mumbai Patient Warming Device, Patient Warming Solutions Mumbai, Forced Air Warmer Equipment Mumbai, Patient Warming Devices Mumbai, Mumbai Thermoregulation System, Mumbai Temperature Control Warming Devices, Mumbai Hospital Warming Equipment"
    />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet>
  
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>



      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/3.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#1A76D1', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for  Pharmacle Health Care Private Limited</h3>
              
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
            
                <TestimonialKeyword testimonials={testimonialsData} />


              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a href={e.link} className="d-flex justify-content-around align-items-center">
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Gallery</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}

                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #1A76D1',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#1A76D1' }}>
                      <div>
                        <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>

                      <div className=''>
                        <a href="tel:+918956322311" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8956322311
                        </a>
                        <a href="tel:+918421773700" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8421773700
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@wallabieswarmcares.com" className=" text-white d-block">
                          <i className="fas fa-envelope darkcolorrr"></i> info@wallabieswarmcares.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                          <i className="fas fa-map-marker-alt darkcolorrr"></i>  Pharmacle Health Care Private Limited <br />
                          Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Nagar Road, Sanaswadi, Pune, Maharashtra, 412208


                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Forcedwarmermumbai;